module.exports = __webpack_public_path__ + "static/media/fruits_46.70aacb4b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_46.csv
// module id = 713
// module chunks = 0